import { GrowthUnifiedProfile } from "./unified-profile.schema";

export type GetGrowthUnifiedProfileResponse = {
    growthUnifiedProfile_getUnifiedProfile: GrowthUnifiedProfile;
};

export type UpdateGrowthUnifiedProfileResponse = {
    growthUnifiedProfile_createUnifiedProfile: GrowthUnifiedProfile;
};

export type GetGrowthUnifiedProfileArgs = {
    accountId?: string;
    tenantId?: string;
    anonymousId?: string;
};

export enum OptionalFields {
    SITES = "sites",
    PAID_CHANNEL_CONTEXT = "paidChannelContext",
    USER_FOOTPRINTS = "userFootprints",
    ONBOARDING_CONTEXT = "onboardingContext",
    USER_PROFILE = "userProfile",
    USER_PROFILE_JOB_FUNCTION = "userProfileJobFunction"
}

export type OptionalHeaderUseCase = {
    useCase?: string;
};

export type GrowthUnifiedProfileClientOptions = {
    // Use a slauth token when authenticating service-to-service requests
    // Note: do not include the "SLAUTH" prefix in the token
    slauthToken?: string;
};
